export default "__VITE_ASSET__D$$NNBIx__"